<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Cuentas Corrientes</h4>
            <div class="small text-muted">Vista de cuentas corrientes de clientes.</div>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="3">
                <FindObject render="search"
                        type="customers" 
                        @select-object="loadCustomers($event)" 
                        :valueID="filters.customers_id"/>
              </b-col>         
              <b-col sm="2">
                <FindObject render="search"
                        type="erpPointsSales" 
                        display="full_identification"
                        @select-object="loadPointSales($event)" 
                        :valueID="filters.points_sales_id"/>
              </b-col>                          
              <b-col md="2">
                <b-form-group label="Desde">    
                  <b-form-input type="date" size="sm" v-model="filters.date_start" placeholder="Fecha Desde"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Hasta">    
                  <b-form-input type="date" size="sm" v-model="filters.date_end" placeholder="Fecha Hasta"></b-form-input>
                </b-form-group>
              </b-col>                                 
              <b-col sm="3" class="mt-4">
                <b-button variant="outline-dark" @click="filterReport()">
                  <b-icon icon="filter" size="sm" class="mr-1" style="font-size:15px;"></b-icon>              
                  Filtrar
                </b-button>
              </b-col>                                     
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
              <b-tab title="Por Factura" @click="setTabActive('invoice')">               
                <b-table class="mb-0"
                        responsive="sm"
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="false"                    
                        :fields="tableInvoice.fields"                      
                        :items="formartedItemsInvoice"
                        selectable
                        select-mode="single"
                        @row-selected="onRowSelected"
                        :busy="tableInvoice.isBusy"       
                        v-if="tableInvoice.items.length || tableInvoice.isBusy">

                  <template v-slot:row-details="row">
                    <b-card no-body>
                      <b-row class="p-3">
                        <b-col md="6">
                          <b-table class="mb-0 table-full-detail-sales"
                                  responsive
                                  head-variant="dark"
                                  :hover="true"
                                  :small="true"
                                  :fixed="true"
                                  :items="tableDetailsSales.imputation.items"
                                  :fields="tableDetailsSales.imputation.fields"
                                  v-if="tableDetailsSales.imputation.items.length">                       
                              
                            <template v-slot:table-colgroup="scope">
                              <col
                                v-for="field in scope.fields"                    
                                :key="field.key"
                                :style="{ width: field.width }"
                              >
                            </template>           

                            <template v-slot:cell(date)="data"> 
                              {{moment(data.item.date).format('DD/MM/YYYY')}}
                            </template>              

                            <template v-slot:cell(reference)="data"> 
                              {{data.item.reference}}                          
                            </template>

                            <template v-slot:cell(amount_total)="data"> 
                              {{Intl.NumberFormat('es-AR',{style:'currency',currency: itemSelectedSales.currency.code}).format(data.item.amount_total)}}           
                            </template>         

                          </b-table>
                          <b-alert v-else variant="info" show>No se encontraron comprobantes imputados</b-alert>              
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>

                  <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Cargando...</strong>
                    </div>
                  </template>

                  <template v-slot:cell(business)="data">
                    {{data.item.business}}
                  </template>

                  <template v-slot:cell(date)="data">
                    <div v-if="data.item.date">
                      {{ moment(data.item.date).format('DD MMMM YYYY') }}
                    </div>
                  </template>

                  <template v-slot:cell(date_expiration)="data">
                    <div v-if="data.item.date_expiration">
                      {{ moment(data.item.date_expiration).format('DD MMMM YYYY') }}
                    </div>
                  </template>

                  <template v-slot:cell(description)="data">
                    {{data.item.description}}
                  </template>

                  <template v-slot:cell(debit)="data">
                      <div v-if="data.item.debit" style="color:green;">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.debit)}}
                      </div>                  
                  </template>

                  <template v-slot:cell(credit)="data">
                      <div v-if="data.item.credit" style="color:red;">
                        ({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.credit)}})
                      </div>
                  </template>

                  <template v-slot:cell(balance)="data">
                    <div v-if="data.item.debit" style="color:green;">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.balance)}}
                    </div>
                    <div v-if="data.item.credit" style="color:red;">
                      ({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.balance)}})
                    </div>
                  </template>

                  <template v-slot:cell(accumulated)="data">
                    <b v-if="data.item.accumulated">                      
                      <b v-if="data.index==0">
                        <span :class="{'current-accounts-accumulate-positive-total':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative-total':parseFloat(data.item.accumulated)<0}">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                        </span>                      
                      </b>
                      <b v-else>
                        <span :class="{'current-accounts-accumulate-positive':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative':parseFloat(data.item.accumulated)<0}">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                        </span>
                      </b>                      
                    </b>     
                  </template>

                  <template v-slot:cell(f_action)="data">
                    <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right" v-if="data.item.print">
                      <b-dropdown-header>Acciones</b-dropdown-header>
                      <b-dropdown-item @click="sendPrinter(data.item)">
                        <b-icon icon="printer"></b-icon> Imprimir
                      </b-dropdown-item>
                      <b-dropdown-item @click="openDetail(data.item)">
                        <b-icon icon="card-text"></b-icon> Ver Detalle
                      </b-dropdown-item>                      
                    </b-dropdown>
                  </template>                  
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>              
              </b-tab>            
              <b-tab title="Pendiente" @click="setTabActive('pending')">             
                <b-table class="mb-0"
                        responsive="sm"
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="false"                  
                        :fields="tablePending.fields"                    
                        :items="formartedItemsPending"
                        selectable
                        select-mode="single"
                        :busy="tablePending.isBusy"     
                        v-if="tablePending.items.length || tablePending.isBusy">

                  <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Cargando...</strong>
                    </div>
                  </template>

                  <template v-slot:cell(business)="data">
                    {{data.item.business}}
                  </template>

                  <template v-slot:cell(date)="data">
                    <div v-if="data.item.date">
                      {{ moment(data.item.date).format('DD MMMM YYYY') }}
                    </div>
                  </template>

                  <template v-slot:cell(date_expiration)="data">
                    <div v-if="data.item.date_expiration">
                      {{ moment(data.item.date_expiration).format('DD MMMM YYYY') }}
                    </div>
                  </template>

                  <template v-slot:cell(description)="data">
                    {{data.item.description}}
                  </template>

                  <template v-slot:cell(debit)="data">
                      <div v-if="data.item.debit" style="color:green;">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.debit)}}
                      </div>                  
                  </template>

                  <template v-slot:cell(credit)="data">
                      <div v-if="data.item.credit" style="color:red;">
                        ({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.credit)}})
                      </div>
                  </template>

                  <template v-slot:cell(accumulated)="data">
                    <b v-if="data.item.accumulated">                      
                      <b v-if="data.index==0">
                        <span :class="{'current-accounts-accumulate-positive-total':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative-total':parseFloat(data.item.accumulated)<0}">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                        </span>                      
                      </b>
                      <b v-else>
                        <span :class="{'current-accounts-accumulate-positive':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative':parseFloat(data.item.accumulated)<0}">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                        </span>
                      </b>                      
                    </b>     
                  </template>

                  <template v-slot:cell(f_action)="data">
                    <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right" v-if="data.item.print">
                      <b-dropdown-header>Acciones</b-dropdown-header>
                      <b-dropdown-item @click="sendPrinter(data.item)">
                        <b-icon icon="printer"></b-icon> Imprimir
                      </b-dropdown-item>
                      <b-dropdown-item @click="openDetail(data.item)">
                        <b-icon icon="card-text"></b-icon> Ver Detalle
                      </b-dropdown-item>                      
                    </b-dropdown>
                  </template>                  
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>              
              </b-tab>
              <b-tab title="Histórica" @click="setTabActive('history')" > 
                <b-table class="mb-0"
                        responsive="sm"
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="false"                    
                        :fields="tableHistory.fields"
                        :items="formartedItemsHistory"
                        selectable
                        select-mode="single"
                        :busy="tableHistory.isBusy"       
                        v-if="tableHistory.items.length || tableHistory.isBusy">

                  <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Cargando...</strong>
                    </div>
                  </template>

                  <template v-slot:cell(business)="data">
                    {{data.item.business}}
                  </template>

                  <template v-slot:cell(date)="data">
                    <div v-if="data.item.date">
                      {{ moment(data.item.date).format('DD MMMM YYYY') }}
                    </div>
                  </template>

                  <template v-slot:cell(date_expiration)="data">
                    <div v-if="data.item.date_expiration">
                      {{ moment(data.item.date_expiration).format('DD MMMM YYYY') }}
                    </div>
                  </template>

                  <template v-slot:cell(description)="data">
                    {{data.item.description}}
                  </template>

                  <template v-slot:cell(debit)="data">
                      <div v-if="data.item.debit" style="color:green;">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.debit)}}
                      </div>                  
                  </template>

                  <template v-slot:cell(credit)="data">
                      <div v-if="data.item.credit" style="color:red;">
                        ({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.credit)}})
                      </div>
                  </template>

                  <template v-slot:cell(accumulated)="data">
                      <b v-if="data.item.accumulated">                      
                        <b v-if="data.index==0">
                          <span :class="{'current-accounts-accumulate-positive-total':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative-total':parseFloat(data.item.accumulated)<0}">
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                          </span>                      
                        </b>
                        <b v-else>
                          <span :class="{'current-accounts-accumulate-positive':parseFloat(data.item.accumulated)>=0, 'current-accounts-accumulate-negative':parseFloat(data.item.accumulated)<0}">
                            {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency}).format(data.item.accumulated)}}
                          </span>
                        </b>                      
                      </b>              
                  </template>

                  <template v-slot:cell(f_action)="data">
                    <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right" v-if="data.item.print">
                      <b-dropdown-header>Acciones</b-dropdown-header>
                      <b-dropdown-item @click="sendPrinter(data.item)">
                        <b-icon icon="printer"></b-icon> Imprimir
                      </b-dropdown-item>
                      <b-dropdown-item @click="openDetail(data.item)">
                        <b-icon icon="card-text"></b-icon> Ver Detalle
                      </b-dropdown-item>                          
                    </b-dropdown>
                  </template>
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>        
        </b-row>
      </b-card>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id" 
              :reference="crud.print.reference" 
              :registerID="crud.print.id"
              :key="crud.print.key"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD DETAILS SALES -->
      <!-- podemos hacer un componente que muestre un modal de todos los datos de este comprobantes
           se repite en la vista sales 
      -->            
      <b-modal v-model="modal.detailSales.active"
              header-bg-variant="dark"
              header-text-variant="white"
              size="xl">
        <div slot="modal-header">
          {{this.modal.detailSales.title}}
        </div>

        <b-row>
          <b-col sm="12">                     
            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
              <b-tab title="General">
                <table class="table table-hover table-sm" v-if="itemSelectedSales">
                  <tbody>
                    <tr>
                      <td class="crud-sales-title-table-custom align-middle">ID</td>
                      <td class="crud-sales-value-table-custom align-middle">
                        <b>#{{this.itemSelectedSales.id}}</b>
                      </td>
                    </tr>  
                    <tr>
                      <td class="crud-sales-title-table-custom align-middle">Empresa</td>
                      <td class="crud-sales-value-table-custom align-middle">
                        {{this.itemSelectedSales.point_sale.business.reference}}
                      </td>
                    </tr>                                            
                    <tr v-if="itemSelectedSales.type_voucher && itemSelectedSales.point_sale">
                      <td class="crud-sales-title-table-custom align-middle">Comprobante</td>                      
                      <td class="crud-sales-value-table-custom align-middle">
                        <b>{{this.itemSelectedSales.type_voucher.name + ' '  + this.itemSelectedSales.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelectedSales.number.toString().padStart(8,'0')}}</b>
                      </td>
                    </tr>                                                           
                    <tr v-if="itemSelectedSales.staff || itemSelectedSales.seller">
                      <td class="crud-sales-title-table-custom align-middle">Emisor</td>                      
                      <td class="crud-sales-value-table-custom align-middle">
                        <div v-if="itemSelectedSales.seller">
                          {{itemSelectedSales.seller.name}}  
                        </div>
                        <div v-else>
                          {{itemSelectedSales.staff.name}}  
                        </div>                        
                      </td>
                    </tr>                                                             
                    <tr>
                      <td class="crud-sales-title-table-custom align-middle">Fecha</td>
                      <td class="crud-sales-value-table-custom align-middle">
                        {{moment(this.itemSelectedSales.date).format('DD MMMM YYYY')}}
                      </td>
                    </tr>                      
                    <tr>
                      <td class="crud-sales-title-table-custom align-middle">Fecha Vencimiento</td>
                      <td class="crud-sales-value-table-custom align-middle">
                        {{moment(this.itemSelectedSales.date_expiration).format('DD MMMM YYYY')}}
                      </td>
                    </tr>                                          
                    <tr v-if="itemSelectedSales.point_sale">
                      <td class="crud-sales-title-table-custom align-middle">Punto de Venta</td>
                      <td class="crud-sales-value-table-custom align-middle">
                        {{this.itemSelectedSales.point_sale.point_sale}} - {{this.itemSelectedSales.point_sale.name}}                          
                      </td>
                    </tr>                                           
                    <tr v-if="itemSelectedSales.customer">
                      <td class="crud-sales-title-table-custom align-middle">Cliente</td>
                      <td class="crud-sales-value-table-custom align-middle">
                        {{this.itemSelectedSales.customer.name}}                        
                      </td>
                    </tr>                      
                    <tr v-if="itemSelectedSales.method_payment">
                      <td class="crud-sales-title-table-custom align-middle">Método de Pago</td>
                      <td class="crud-sales-value-table-custom align-middle">
                        {{this.itemSelectedSales.method_payment.name}}                        
                      </td>
                    </tr>                                                  
                    <tr v-if="itemSelectedSales.currency">
                      <td class="crud-sales-title-table-custom align-middle">SubTotal</td>
                      <td class="crud-sales-value-table-custom align-middle">                                    
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelectedSales.currency.code}).format(this.itemSelectedSales.amount_net)}}                        
                      </td>
                    </tr>  
                    <tr v-if="itemSelectedSales.currency && itemSelectedSales.amount_discount > 0">
                      <td class="crud-sales-title-table-custom align-middle">Descuento ({{itemSelectedSales.percentage_discount}} %)</td>
                      <td class="crud-sales-value-table-custom align-middle">                                    
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelectedSales.currency.code}).format(this.itemSelectedSales.amount_discount)}}                        
                      </td>
                    </tr>                                          
                    <tr v-if="itemSelectedSales.currency">
                      <td class="crud-sales-title-table-custom align-middle">IVA</td>
                      <td class="crud-sales-value-table-custom align-middle">                                    
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelectedSales.currency.code}).format(this.itemSelectedSales.amount_iva)}}                        
                      </td>
                    </tr>                                          
                    <tr v-if="itemSelectedSales.currency">
                      <td class="crud-sales-title-table-custom align-middle">Total</td>
                      <td class="crud-sales-value-table-custom align-middle">    
                        <div style="color:red" v-if="itemSelectedSales.type_voucher.type_balance == '-'">                    
                          <b>({{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelectedSales.currency.code}).format(this.itemSelectedSales.amount_total)}})</b>                        
                        </div>
                        <div v-else>                    
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelectedSales.currency.code}).format(this.itemSelectedSales.amount_total)}}</b>                        
                        </div>
                      </td>
                    </tr>          
                    <tr v-if="itemSelectedSales.amount_impute!=itemSelectedSales.amount_total">
                      <td class="crud-sales-title-table-custom align-middle">Pendiente de Imputación</td>
                      <td class="crud-sales-value-table-custom align-middle table-warning">    
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelectedSales.currency.code}).format(getPendingVoucherSale(this.itemSelectedSales))}}</b>                        
                      </td>
                    </tr>                                    
                    <tr v-if="itemSelectedSales.observations">
                      <td class="crud-sales-title-table-custom align-middle">Observaciones</td>
                      <td class="crud-sales-value-table-custom align-middle">                        
                        {{this.itemSelectedSales.observations}}
                      </td>
                    </tr>                                               
                  </tbody>
                </table>
              </b-tab>  

              <b-tab title="Items">                
                <b-table class="mb-0 table-full-detail-sales"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetailsSales.items.items"
                        :fields="tableDetailsSales.items.fields"
                        v-if="tableDetailsSales.items.items.length">                       
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>           

                  <template v-slot:cell(code)="data">                           
                    <div v-html="getDetailCode(data.item)"></div>
                  </template>

                  <template v-slot:cell(product)="data">                           
                    <div v-html="getDetailName(data.item)"></div>
                  </template>
                  
                  <template v-slot:cell(quantity)="data">   
                    {{data.item.quantity}}                        
                    <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
                  </template>

                  <template v-slot:cell(unit_price)="data">                          
                    <div v-if="itemSelectedSales.currency">                      
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelectedSales.currency.code}).format(data.item.price_unit)}}                      
                    </div>                    
                  </template>                  

                  <template v-slot:cell(amount_net)="data">                          
                    <div v-if="itemSelectedSales.currency">                      
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelectedSales.currency.code}).format(data.item.amount_net)}}                      
                    </div>                    
                  </template>  

                  <template v-slot:cell(subtotal)="data">                          
                    <div v-if="itemSelectedSales.currency">                      
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelectedSales.currency.code}).format(parseFloat(data.item.quantity) * parseFloat(data.item.price_unit))}}                      
                    </div>                    
                  </template>                  

                  <template v-slot:cell(amount_iva)="data">                          
                    <div v-if="itemSelectedSales.currency">                      
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelectedSales.currency.code}).format(data.item.amount_iva)}}                      
                    </div>                    
                  </template>                  

                  <template v-slot:cell(amount_discount)="data">                          
                    <div v-if="itemSelectedSales.currency">  
                      ({{parseFloat(data.item.percentage_discount).toFixed(0)}}%)                    
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelectedSales.currency.code}).format(data.item.amount_discount)}}                      
                    </div>                    
                  </template>                  
                  
                  <template v-slot:cell(amount_total)="data">                           
                    <div v-if="itemSelectedSales.currency">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelectedSales.currency.code}).format(data.item.amount_total)}}
                    </div>                    
                  </template>                  
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-tab>     

              <b-tab title="Imputaciones" v-if="tableDetailsSales.imputation.items.length">                
                <b-table class="mb-0 table-full-detail-sales"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetailsSales.imputation.items"
                        :fields="tableDetailsSales.imputation.fields">                       
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>           

                  <template v-slot:cell(date)="data"> 
                    {{moment(data.item.date).format('DD/MM/YYYY')}}
                  </template>              

                  <template v-slot:cell(reference)="data"> 
                    {{data.item.reference}}                          
                  </template>

                  <template v-slot:cell(amount_total)="data"> 
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: itemSelectedSales.currency.code}).format(data.item.amount_total)}}           
                  </template>         

                </b-table>
              </b-tab>

              <b-tab title="Asiento" v-if="showContabilidad">
                <b-table class="mb-0 table-full-detail-sales"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetailsSales.accounting.items"
                        :fields="tableDetailsSales.accounting.fields"
                        v-if="tableDetailsSales.accounting.items.length">                       
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>                                                                                     

                  <template v-slot:cell(code)="data">
                    <div v-if="data.item.type=='Debe'">
                      <span>{{data.item.accounting_accounts_code}}</span>
                    </div>
                    <div v-if="data.item.type=='Haber'">
                      <span class="ml-5">{{data.item.accounting_accounts_code}}</span>
                    </div>
                  </template>  

                  <template v-slot:cell(name)="data">
                    <div v-if="data.item.type=='Debe'">
                      <span>{{data.item.accounting_accounts_name}}</span>
                    </div>
                    <div v-if="data.item.type=='Haber'">
                      <span class="ml-5">{{data.item.accounting_accounts_name}}</span>
                    </div>                                                          
                  </template>

                  <template v-slot:cell(debit)="data">
                    <span v-if="data.item.type == 'Debe'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(data.item.total)}}
                    </span>
                  </template>

                  <template v-slot:cell(credit)="data">
                    <span v-if="data.item.type == 'Haber'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(data.item.total)}}
                    </span>
                  </template>
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-tab>
            </b-tabs>

          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.detailSales.active=false">Cancelar</b-button>                   
        </div>
      </b-modal>

      <!-- CRUD DETAILS RECEIPTS -->
      <!-- podemos hacer un componente que muestre un modal de todos los datos de este comprobantes
           se repite en la vista receipts
      -->            
      <b-modal v-model="modal.detailReceipts.active"
              header-bg-variant="dark"
              header-text-variant="white"
              size="xl">
        <div slot="modal-header">
          {{this.modal.detailReceipts.title}}
        </div>

        <b-row>
          <b-col sm="12">                     
            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
              <b-tab title="General">
                <table class="table table-hover table-sm" v-if="itemSelectedReceipts">
                  <tbody>
                    <tr>
                      <td class="crud-receipts-title-table-custom align-middle">ID</td>
                      <td class="crud-receipts-value-table-custom align-middle">
                        <b>#{{this.itemSelectedReceipts.id}}</b>
                      </td>
                    </tr>  
                    <tr>
                      <td class="crud-receipts-title-table-custom align-middle">Empresa</td>
                      <td class="crud-receipts-value-table-custom align-middle">
                        {{this.itemSelectedReceipts.point_sale.business.reference}}
                      </td>
                    </tr>                                        
                    <tr v-if="itemSelectedReceipts.type_voucher && itemSelectedReceipts.point_sale">
                      <td class="crud-receipts-title-table-custom align-middle">Comprobante</td>                      
                      <td class="crud-receipts-value-table-custom align-middle">
                        <b>{{this.itemSelectedReceipts.type_voucher.name + ' '  + this.itemSelectedReceipts.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelectedReceipts.number.toString().padStart(8,'0')}}</b>
                      </td>
                    </tr>                                                           
                    <tr v-if="itemSelectedReceipts.staff">
                      <td class="crud-receipts-title-table-custom align-middle">Emisor</td>                      
                      <td class="crud-receipts-value-table-custom align-middle">
                        <div v-if="itemSelectedReceipts.staff">
                          {{itemSelectedReceipts.staff.name}}
                        </div> 
                      </td>
                    </tr>                                                             
                    <tr>
                      <td class="crud-receipts-title-table-custom align-middle">Fecha</td>
                      <td class="crud-receipts-value-table-custom align-middle">
                        {{moment(this.itemSelectedReceipts.date).format('DD MMMM YYYY')}}
                      </td>
                    </tr>                                          
                    <tr v-if="itemSelectedReceipts.point_sale">
                      <td class="crud-receipts-title-table-custom align-middle">Punto de Venta</td>
                      <td class="crud-receipts-value-table-custom align-middle">
                        {{this.itemSelectedReceipts.point_sale.point_sale}} - {{this.itemSelectedReceipts.point_sale.name}}                          
                      </td>
                    </tr>                                           
                    <tr v-if="itemSelectedReceipts.customer">
                      <td class="crud-receipts-title-table-custom align-middle">Cliente</td>
                      <td class="crud-receipts-value-table-custom align-middle">
                        {{this.itemSelectedReceipts.customer.name}}                        
                      </td>
                    </tr>                        
                    <tr v-if="itemSelectedReceipts.amount_total">
                      <td class="crud-receipts-title-table-custom align-middle">Total</td>
                      <td class="crud-receipts-value-table-custom align-middle">    
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.getCurrency}).format(this.itemSelectedReceipts.amount_total)}}</b>                        
                      </td>
                    </tr>                         
                    <tr v-if="itemSelectedReceipts.observations">
                      <td class="crud-receipts-title-table-custom align-middle">Observaciones</td>
                      <td class="crud-receipts-value-table-custom align-middle">                        
                        {{this.itemSelectedReceipts.observations}}
                      </td>
                    </tr>                         
                    <tr v-if="itemSelectedReceipts.amount_pending">
                      <td class="crud-receipts-title-table-custom align-middle">Pendiente de Imputación</td>
                      <td class="crud-receipts-value-table-custom align-middle table-warning">    
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.getCurrency}).format(this.itemSelectedReceipts.amount_pending)}}</b>                        
                      </td>
                    </tr>                                                                      
                  </tbody>
                </table>
              </b-tab>              
              <b-tab title="Detalle de Pago">                
                <b-table class="mb-0 table-full-detail-receipts"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetailsReceipts.payment.items"
                        :fields="tableDetailsReceipts.payment.fields"
                        v-if="tableDetailsReceipts.payment.items.length">                       
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>           

                  <template v-slot:cell(medio)="row"> 
                    <div v-if="row.item.type=='CASH'">
                      {{row.item.relation.cash.name}}                        
                    </div>
                    <div v-if="row.item.type=='CHEQUE'">
                      CHEQUE
                    </div>
                  </template>

                  <template v-slot:cell(description)="row"> 
                    <div v-if="row.item.type=='CASH'">
                      <b>CAJA/CUENTA:</b> {{row.item.relation.cash.name}} |
                      <b>MONEDA:</b> {{row.item.relation.currency.name}}
                    </div>
                    <div v-if="row.item.type=='CHEQUE'">
                      <b>NUMERO:</b> {{row.item.relation.number}} |
                      <b>BANCO:</b> {{row.item.relation.bank}} |
                      <b>EMISION:</b> {{moment(row.item.relation.date).format('DD/MM/YYYY')}} |
                      <b>VENCIMIENTO:</b> {{moment(row.item.relation.date_expiration).format('DD/MM/YYYY')}} |
                      <b-link :id="'more-data-cheque-' + row.index">Más Datos ...</b-link>

                      <b-popover :target="'more-data-cheque-' + row.index" triggers="hover" placement="auto">
                        <template #title>Datos Cheque</template>
                        <b>NUMERO:</b> {{row.item.relation.number}} <br>
                        <b>BANCO:</b> {{row.item.relation.bank}} <br>
                        <b>EMISION:</b> {{moment(row.item.relation.date).format('DD/MM/YYYY')}} <br>
                        <b>VENCIMIENTO:</b> {{moment(row.item.relation.date_expiration).format('DD/MM/YYYY')}} <br>
                        <b>EMISOR:</b> {{row.item.relation.transmitter_name}} <br>
                        <b>CUIT:</b> {{row.item.relation.transmitter_documents_number}} <br>
                        <b>OBSERVACIONES:</b> {{row.item.relation.observations}}
                      </b-popover>                      
                    </div>
                  </template>                  

                  <template v-slot:cell(amount)="row">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(row.item.amount_total)}}
                  </template>                  
                  
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-tab>
              <b-tab title="Comprobantes Imputados">                
                <b-table class="mb-0 table-full-detail-receipts"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetailsReceipts.imputation.items"
                        :fields="tableDetailsReceipts.imputation.fields"
                        v-if="tableDetailsReceipts.imputation.items.length">                       
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>           

                  <template v-slot:cell(date)="row"> 
                    {{moment(row.item.sales.date).format('DD/MM/YYYY')}}
                  </template>

                  <template v-slot:cell(voucher)="row"> 
                    {{row.item.sales.type_voucher.name + ' ' + row.item.sales.point_sale.point_sale.toString().padStart(4,'0') + '-' + row.item.sales.number.toString().padStart(8,'0')}}
                  </template>

                  <template v-slot:cell(amount_total)="row">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(row.item.sales.amount_total)}}
                  </template>               

                  <template v-slot:cell(amount_pending)="row">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(calcPendingVoucherReceipts(row.item))}}
                  </template>                                 
                  
                  <template v-slot:cell(amount_impute)="row">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(row.item.amount_total)}}
                  </template>                                 
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-tab>   
              <b-tab title="Asiento" v-if="showContabilidad">
                <b-table class="mb-0 table-full-detail-sales"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetailsReceipts.accounting.items"
                        :fields="tableDetailsReceipts.accounting.fields"
                        v-if="tableDetailsReceipts.accounting.items.length">                       
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>                                                                                     

                  <template v-slot:cell(code)="data">
                    <div v-if="data.item.type=='Debe'">
                      <span>{{data.item.accounting_accounts_code}}</span>
                    </div>
                    <div v-if="data.item.type=='Haber'">
                      <span class="ml-5">{{data.item.accounting_accounts_code}}</span>
                    </div>
                  </template>  

                  <template v-slot:cell(name)="data">
                    <div v-if="data.item.type=='Debe'">
                      <span>{{data.item.accounting_accounts_name}}</span>
                    </div>
                    <div v-if="data.item.type=='Haber'">
                      <span class="ml-5">{{data.item.accounting_accounts_name}}</span>
                    </div>                                                          
                  </template>

                  <template v-slot:cell(debit)="data">
                    <span v-if="data.item.type == 'Debe'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(data.item.total)}}
                    </span>
                  </template>

                  <template v-slot:cell(credit)="data">
                    <span v-if="data.item.type == 'Haber'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(data.item.total)}}
                    </span>
                  </template>
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-tab>                         
            </b-tabs>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.detailReceipts.active=false">Cancelar</b-button>                   
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import moment from 'moment'
  import Vue from 'vue'
  import FindObject from '@/components/inc/find/findObject' 
  import Printer from '@/components/inc/printer/printer'

  export default {
    components: {
      FindObject,
      Printer,       
    }, 
    data: () => {
      return {      
        access: {
          module_id: Modules.VENTAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'currentsAccounts',
          elements: {}
        }, 
        tableHistory : {
          items: [],
          filters: null,
          fields: [    
            {key: 'business', label: 'Empresa', class:"align-middle text-left"},        
            {key: 'date', label: 'Fecha', class: "align-middle"},
            {key: 'description', label: 'Comprobante', class: "align-middle"},
            {key: 'date_expiration', label: 'Vencimiento', class: "align-middle"},            
            {key: 'debit', label: 'Debe', class: "align-middle text-right"},
            {key: 'credit', label: 'Haber', class: "align-middle text-right"},         
            {key: 'accumulated', label: 'Acumulado', class: "align-middle text-right"},
            {key: 'f_action', label:'', class: "align-middle"},
          ],          
          isBusy: false,
        },
        tablePending : {
          items: [],
          filters: null,
          fields: [            
            {key: 'business', label: 'Empresa', class:"align-middle text-left"},
            {key: 'date', label: 'Fecha', class: "align-middle"},
            {key: 'description', label: 'Comprobante', class: "align-middle"},
            {key: 'date_expiration', label: 'Vencimiento', class: "align-middle"},            
            {key: 'debit', label: 'Debe', class: "align-middle text-right"},
            {key: 'credit', label: 'Haber', class: "align-middle text-right"},         
            {key: 'accumulated', label: 'Acumulado', class: "align-middle text-right"},
            {key: 'f_action', label:'', class: "align-middle"},
          ],          
          isBusy: false,
        },    
        tableInvoice : {
          items: [],
          filters: null,
          fields: [       
            {key: 'business', label: 'Empresa', class:"align-middle text-left"},     
            {key: 'date', label: 'Fecha', class: "align-middle"},
            {key: 'description', label: 'Comprobante', class: "align-middle"},
            {key: 'date_expiration', label: 'Vencimiento', class: "align-middle"},            
            {key: 'debit', label: 'Debe', class: "align-middle text-right"},
            {key: 'credit', label: 'Haber', class: "align-middle text-right"},         
            {key: 'balance', label: 'Saldo', class: "align-middle text-right"},         
            {key: 'accumulated', label: 'Acumulado', class: "align-middle text-right"},
            {key: 'f_action', label:'', class: "align-middle"},
          ],          
          isBusy: false,
        },            
        tableDetailsSales: {
          items : {
            items: [],
            fields: [
              {key: 'code', label: 'Código', class:"align-middle", width:"50px"},                
              {key: 'product', label: 'Item', class:"align-middle text-truncate", width:"200px"},
              {key: 'quantity', label: 'Cant', class:"align-middle text-right", width:"60px"},             
              {key: 'unit_price', label: 'P.Unit', class:"align-middle text-right", width:"70px"},                
              {key: 'subtotal', label: 'Subtotal', class:"align-middle text-right", width:"70px"},                
              {key: 'amount_discount', label: 'Desc', class:"align-middle text-right", width:"70px"},               
              {key: 'amount_net', label: 'P.Neto', class:"align-middle text-right", width:"70px"},                    
              {key: 'amount_iva', label: 'IVA', class:"align-middle text-right", width:"70px"},                
              {key: 'amount_total', label: 'Total', class:"align-middle text-right", width:"70px"},              
            ]
          },            
          imputation : {
            items: [],
            fields: [
              {key: 'date', label: 'Fecha', class:"align-middle", width:"20%"},                
              {key: 'reference', label: 'Referencia', class:"align-middle", width:"50%"},
              {key: 'amount_total', label: 'Total', class:"align-middle text-right", width:"30%"},                   
            ]
          },  
          accounting : {
            items: [],
            fields: [
              {key: 'code', label: 'Código', class:"align-middle", width:"150px"},                
              {key: 'name', label: 'Nombre', class:"align-middle", width:"250px"},                
              {key: 'debit', label: 'Debe', class:"align-middle", width:"150px"},               
              {key: 'credit', label: 'Haber', class:"align-middle", width:"150px"},              
            ]
          },          
        }, 
        tableDetailsReceipts: {
          payment : {
            items: [],
            fields: [
              {key: 'medio', label: 'Medio', class:"align-middle text-left text-truncate", width:"20%"},
              {key: 'description', label: 'Detalle', class:"align-middle text-left text-truncate", width:"60%"},
              {key: 'amount', label: 'Importe', class:"align-middle text-right", width:"20%"},
            ]
          },            
          imputation : {
            items: [],
            fields: [              
              {key: 'date', label: 'Fecha', class:"align-middle text-center", width:"15%"},
              {key: 'voucher', label: 'Comprobante', class:"align-middle text-left text-truncate", width:"40%"},
              {key: 'amount_total', label: 'Importe Total', class:"align-middle text-right", width:"15%"},
              {key: 'amount_pending', label: 'Importe Pendiente', class:"align-middle text-right", width:"15%"},
              {key: 'amount_impute', label: 'Importe Imputado', class:"align-middle text-right", width:"15%"},
            ]
          },  
          accounting : {
            items: [],
            fields: [
              {key: 'code', label: 'Código', class:"align-middle", width:"150px"},
              {key: 'name', label: 'Nombre', class:"align-middle", width:"250px"},
              {key: 'debit', label: 'Debe', class:"align-middle", width:"150px"},               
              {key: 'credit', label: 'Haber', class:"align-middle", width:"150px"},          
            ]
          },          
        },              
        crud: {
          print: {
            reference: '',
            id: 0,
            key: 0,
          }     
        },
        modal: {
          detailSales: {
            active: false, 
            title: '',
          },  
          detailReceipts: {
            active: false, 
            title: '',
          },                      
        },           
        filters: {
          date_start: '',
          date_end: '',
          customers: null,
          customers_id: 0,          
          points_sales: null,
          points_sales_id: 0,          
        },     
        tabSelect: 'invoice', 
        itemSelectedSales: null,        
        itemSelectedReceipts: null,    
        arr: {
          invoice: [],
        }
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.filterLoad()

      //this.filters.customers_id = 2
      //this.filterReport()
    },
    computed: {
      // MODULES
      showContabilidad() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.CONTABILIDAD) {                             
            status = true                       
          }
        })        
        return status
      },

      // CONFIGURACION      
      getCurrency() {
        return 'ARS'
      },  

      formartedItemsHistory () {
        if (!this.tableHistory.items) return []
        return this.tableHistory.items.map(item => {
          if(!item.print){
            item._rowVariant  = 'secondary'
          }
          
          return item
        })
      },
      formartedItemsPending () {
        if (!this.tablePending.items) return []
        return this.tablePending.items.map(item => {
          if(!item.print){
            item._rowVariant  = 'secondary'
          }
          
          return item
        })
      },
      formartedItemsInvoice () {
        if (!this.tableInvoice.items) return []
        return this.tableInvoice.items.map(item => {
          if(!item.print){
            item._rowVariant  = 'secondary'
          }
          
          return item
        })
      }                  
    },
    methods: {
      onRowSelected(item) {
        this.arr.invoice.forEach((element, index) => {  
          if(item.length) {  
            if(item[0].id>0 && item[0].typeOperation=='sales') {
              if(element.id == item[0].id) {
                if(this.tableInvoice.items[index]._showDetails) {
                  this.tableInvoice.items[index]._showDetails = false
                } else {                
                  this.tableInvoice.rowSelected = index
                  this.filterReport()                
                }                       
              }
            }                        
          } else {
            this.tableInvoice.items[index]._showDetails = false
          }         
        })  
      },
      filterLoad() { 
        this.loadCustomers()
        this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD') 
        this.filters.date_end = moment().format('YYYY-MM-DD') 
      },
      loadCustomers (object) {        
        if(object){
          this.filters.customers = object
          this.filters.customers_id = object.id        

          this.filterReport()                
        } else {
          this.filters.customers = null
          this.filters.customers_id = 0

          this.tableHistory.items = []
          this.tablePending.items = []          
        }
      }, 
      loadPointSales (object) {
        if(object){
          this.filters.points_sales = object
          this.filters.points_sales_id = object.id      

          this.filterReport()                          
        } else {
          this.filters.points_sales = null
          this.filters.points_sales_id = 0          

          this.filterReport()                          
        }
      },      
      filterReport(){
        if(!this.filters.customers_id) {
          this.$awn.alert("Debe seleccionar un cliente");
          return false;
        }
        
        this.tablePending.isBusy = true
        this.tableHistory.isBusy = true
        this.tableInvoice.isBusy = true
                 
        if(this.tabSelect=='history') {
          var resultHistory = serviceAPI.filtrarCurrentsAccounts(this.filters)        
          resultHistory.then((response) => {                                
            this.tablePending.items = []
            this.tableInvoice.items = []
            this.tableHistory.items = response.data            
            
            this.tablePending.isBusy = false
            this.tableHistory.isBusy = false
            this.tableInvoice.isBusy = false
          })          
        }
        if(this.tabSelect=='pending') {          
          var resultPending = serviceAPI.filtrarCurrentsAccountsPending(this.filters)        
          resultPending.then((response) => {                                
            this.tableHistory.items = []
            this.tableInvoice.items = []
            this.tablePending.items = response.data                        

            this.tablePending.isBusy = false
            this.tableHistory.isBusy = false
            this.tableInvoice.isBusy = false
          })                    
        }
        if(this.tabSelect=='invoice') {          
          var resultInvoice = serviceAPI.filtrarCurrentsAccountsInvoice(this.filters)        
          resultInvoice.then((response) => {                                
            this.tableHistory.items = []
            this.tablePending.items = []
            this.tableInvoice.items = response.data
            
            this.arr.invoice  = response.data

            this.tablePending.isBusy = false
            this.tableHistory.isBusy = false
            this.tableInvoice.isBusy = false

            if(this.tableInvoice.rowSelected!=null) {              
              this.tableInvoice.items[this.tableInvoice.rowSelected]._showDetails = true      
              
              var result = serviceAPI.filtrarComprobanteById({
                id: this.tableInvoice.items[this.tableInvoice.rowSelected].regID,
              }) 
              result.then((response) => {    
                var data = response.data
                this.itemSelectedSales = data

                // IMPUTACIONES
                var arrImputations = []        
                if(data.receipts) {
                  data.receipts.forEach(element => {
                    arrImputations.push({
                      date: element.receipts.date,
                      reference: element.receipts.type_voucher.name + ' ' + element.receipts.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.receipts.number.toString().padStart(8,'0'),
                      amount_total: element.amount_total
                    })
                  });
                }
              
                if(data.sales_related) {          
                  data.sales_related.forEach(element => {              
                    arrImputations.push({
                      date: element.sale_related.date,
                      reference: element.sale_related.type_voucher.name + ' ' + element.sale_related.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.sale_related.number.toString().padStart(8,'0'),
                      amount_total: element.amount_total
                    })
                  });
                }   
              
                if(data.sales_related_n_c) {          
                  data.sales_related_n_c.forEach(element => {              
                    arrImputations.push({
                      date: element.sale.date,
                      reference: element.sale.type_voucher.name + ' ' + element.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.sale.number.toString().padStart(8,'0'),
                      amount_total: element.amount_total
                    })
                  });
                }   

                this.tableDetailsSales.imputation.items = arrImputations                    
              })
            }            
          })                    
        }        
      },
      sendPrinter(item) {
        this.crud.print.key=Math.random()
        this.crud.print.id=item.regID
        this.crud.print.reference=item.reportDefault        
      },
      setTabActive(type) {        
        this.tabSelect = type
        if(this.filters.customers_id) {
          this.filterReport()                
        }
      },

      // DETALLE
      openDetail(item) {                
        if(item.typeOperation == 'sales') {
          this.openDetailSale(item)
        } else {
          this.openDetailReceipt(item)
        }
      },
      openDetailSale(item) {                       
        var result = serviceAPI.filtrarComprobanteById({
          id: item.regID,
        })        
        result.then((response) => {               
          var data = response.data
          this.itemSelectedSales = data
          
          // DETALLE
          this.tableDetailsSales.items.items = this.itemSelectedSales.details

          // IMPUTACIONES
          var arrImputations = []        
          if(data.receipts) {
            data.receipts.forEach(element => {
              arrImputations.push({
                date: element.receipts.date,
                reference: element.receipts.type_voucher.name + ' ' + element.receipts.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.receipts.number.toString().padStart(8,'0'),
                amount_total: element.amount_total
              })
            });
          }
        
          if(data.sales_related) {          
            data.sales_related.forEach(element => {              
              arrImputations.push({
                date: element.sale_related.date,
                reference: element.sale_related.type_voucher.name + ' ' + element.sale_related.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.sale_related.number.toString().padStart(8,'0'),
                amount_total: element.amount_total
              })
            });
          }   
        
          if(data.sales_related_n_c) {          
            data.sales_related_n_c.forEach(element => {              
              arrImputations.push({
                date: element.sale.date,
                reference: element.sale.type_voucher.name + ' ' + element.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.sale.number.toString().padStart(8,'0'),
                amount_total: element.amount_total
              })
            });
          }   

          this.tableDetailsSales.imputation.items = arrImputations          

          // CONTABILIDAD
          if(this.itemSelectedSales.accounting_entries){
            if(this.itemSelectedSales.accounting_entries.details){
              this.tableDetailsSales.accounting.items = this.itemSelectedSales.accounting_entries.details
            } else {
              this.tableDetailsSales.accounting.items = []
            }
          } else {
            this.tableDetailsSales.accounting.items = []
          }

          this.modal.detailSales.title = "Detalle del Comprobante"
          this.modal.detailSales.active = true
        })                         
      },    
      openDetailReceipt(item) {
        var result = serviceAPI.filtrarRecibosById({
          id: item.regID,
        })        
        result.then((response) => {               
          var data = response.data
          this.itemSelectedReceipts = data

          this.tableDetailsReceipts.payment.items = this.itemSelectedReceipts.details_payments
          this.tableDetailsReceipts.imputation.items = this.itemSelectedReceipts.details_imputations

          if(this.itemSelectedReceipts.accounting_entries){
            if(this.itemSelectedReceipts.accounting_entries.details){
              this.tableDetailsReceipts.accounting.items = this.itemSelectedReceipts.accounting_entries.details
            } else {
              this.tableDetailsReceipts.accounting.items = []
            }
          } else {
            this.tableDetailsReceipts.accounting.items = []
          }

          this.modal.detailReceipts.title = "Detalle del Comprobante"
          this.modal.detailReceipts.active = true          
        })
      },
      getPendingVoucherSale(item) {
        return parseFloat(item.amount_total) - parseFloat(item.amount_impute)
      },  
      calcPendingVoucherReceipts(item) {
        return parseFloat(item.sales.amount_total) - parseFloat(item.sales.amount_impute)
      },          
      getDetailCode(item) {        
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductCode(item)
        }
        if(item.services_id) {
          return item.service.code
        }        
        if(item.concepts_id) {
          return item.concept.code
        }   
        if(item.products_compound_id) {          
          return item.products_compound.code
        }                       
      },
      getDetailName(item) {
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductName(item)
        }
        if(item.services_id) {
          return item.description
        }        
        if(item.concepts_id) {          
          return item.description
        }   
        if(item.products_compound_id) {          
          return item.description
        }                      
      },    
      getProductCode(item) {
        var code = ''
        var prod = null

        if(item.code) {
          code = item.code
        }          

        if(item.products_id) {
          if(code) {
            return code
          } else {                      
            return item.product.code
          }
        }

        if(item.products_colors_id) {
          prod = item.products_color 
          if(code) {
            return code
          } else {
            return prod.code
          }           
        }

        if(item.products_waist_id) {
          prod = item.products_waist 
          if(code) {
            return code
          } else {
            return prod.code
          }                     
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist 
          if(code) {
            return code
          } else {
            return prod.code
          }                     
        }
      },      
      getProductName(item) {        
        var name = ''
        var prod = null

        if(item.description) {
          name = item.description
        }          
        
        if(item.products_id) {
          if(name) {
            return name
          } else {
            return item.product.name
          }          
        }

        if(item.products_colors_id) {
          prod = item.products_color 
          if(name) {
            return name + ' (' + prod.color.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ')'
          }                    
        }

        if(item.products_waist_id) {
          prod = item.products_waist           
          if(name) {
            return name + ' (' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.waist.name + ')'
          }
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist 
          if(name) {
            return name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          }          
        }
      },  
    }    
  }
</script>
<style scoped>
  .crud-sales-title-table-custom {
    color: #fff;
    background-color: #2f353a;
    border-color: #40484f;
    font-weight: 700;
    padding-right: 10px;
    width: 30%;
    text-align: right
  }
  .crud-sales-value-table-custom {
    padding-left: 5px;
    white-space: pre-line;
  }  
  .crud-receipts-title-table-custom {
    color: #fff;
    background-color: #2f353a;
    border-color: #40484f;
    font-weight: 700;
    padding-right: 10px;
    width: 30%;
    text-align: right
  }
  .crud-receipts-value-table-custom {
    padding-left: 5px;
    white-space: pre-line;
  }    
  .current-accounts-accumulate-negative-total {  
    font-size: 16px;
    color: white;
    background: red;
    padding: 3px;    
  }
  .current-accounts-accumulate-positive-total {
    font-size: 16px;
    color: white;
    background: green;
    padding: 3px;        
  }  
  .current-accounts-accumulate-negative {      
    color: red;
  }
  .current-accounts-accumulate-positive {    
    color: green;
  }    
</style>